import httpClient from '@/api/http-client';

const endpoint = 'api/work-places';

const workPlaceService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (search) => httpClient.post(`${endpoint}/find`, { search }),

  create: (workPlace) => httpClient.post(`${endpoint}`, workPlace),

  update: (workPlace) => httpClient.put(`${endpoint}/${workPlace.id}`, workPlace),

  delete: (workPlace) => httpClient.delete(`${endpoint}/${workPlace.id}`),
};

export default workPlaceService;
